import local from 'local-links';

export default () => {
	[...document.querySelectorAll('a')]
		.filter(a => {
			if (
				(local.isLocal('click', a, true) === null &&
					a.href !== window.location.href) ||
				a.href.indexOf('resources') >= 0
			) {
				return a;
			}
		})
		.forEach(a => {
			a.setAttribute('target', '_blank');
			a.setAttribute('rel', 'noopener');
		});
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
